import { activeSiteConfig } from "@config/site/site-config";

export const filterValuesDistance = {
    US: [
        { value: 25, label: "25 miles" },
        { value: 50, label: "50 miles" },
        { value: 100, label: "100 miles" },
        { value: 300, label: "300 miles" },
        { value: "COUNTRY", label: activeSiteConfig.countryName },
    ],

    JP: [
        { value: 25, label: "25km以内" },
        { value: 50, label: "50km以内" },
        { value: 100, label: "100km以内" },
        { value: 300, label: "300km以内" },
        { value: "COUNTRY", label: "日本すべて" },
    ],
    Default: [
        { value: 25, label: "25 km" },
        { value: 50, label: "50 km" },
        { value: 200, label: "200 km" },
        {
            value: "COUNTRY",
            label: activeSiteConfig.countryName,
        },
    ],
};

export const filterValueStoreType = [
    { value: "storeType", label: "ECCO Stores" },
    { value: "distance", label: "Distance" },
];
